module.exports = __webpack_public_path__ + "static/media/heart.2c9a7d4c.png";